import axiosInstance from './axiosInstance';

// Public product endpoints
export const getProducts = async (category = null) => {
  const params = category ? { category } : {};
  const response = await axiosInstance.get('/api/products', { params });
  return response.data;
};

export const getProductById = async (productId) => {
  const response = await axiosInstance.get(`/api/products/${productId}`);
  return response.data;
};

export const searchProducts = async (searchTerm) => {
  const response = await axiosInstance.get('/api/products/search', {
    params: { q: searchTerm }
  });
  return response.data;
};

export const getNewArrivals = async () => {
  const response = await axiosInstance.get('/api/new-arrivals');
  return response.data;
};

export const getHomepageData = async () => {
  const response = await axiosInstance.get('/api/homepage');
  return response.data;
};

// Admin product endpoints
export const getAdminProducts = async () => {
  const response = await axiosInstance.get('/api/admin/products');
  return response.data;
};

export const createProduct = async (productData) => {
  const formData = new FormData();
  
  Object.keys(productData).forEach(key => {
    if (key === 'images' && Array.isArray(productData[key])) {
      productData[key].forEach((file, index) => {
        formData.append('images', file);
      });
    } else if (Array.isArray(productData[key])) {
      formData.append(key, productData[key].join(','));
    } else {
      formData.append(key, productData[key]);
    }
  });

  const response = await axiosInstance.post('/api/admin/products', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateProduct = async (productId, productData) => {
  const formData = new FormData();
  
  Object.keys(productData).forEach(key => {
    if (key === 'images' && Array.isArray(productData[key])) {
      productData[key].forEach((file) => {
        if (file instanceof File) {
          formData.append('images', file);
        }
      });
    } else if (Array.isArray(productData[key])) {
      formData.append(key, productData[key].join(','));
    } else {
      formData.append(key, productData[key]);
    }
  });

  const response = await axiosInstance.put(`/api/admin/products/${productId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteProduct = async (productId) => {
  const response = await axiosInstance.delete(`/api/admin/products/${productId}`);
  return response.data;
};

export const deleteProductImage = async (productId, imageId) => {
  const response = await axiosInstance.delete(`/api/admin/products/${productId}/images/${imageId}`);
  return response.data;
};

export const getAdminNewArrivals = async () => {
  const response = await axiosInstance.get('/api/admin/new-arrivals');
  return response.data;
};

export const getAdminTrendingProducts = async () => {
  const response = await axiosInstance.get('/api/admin/trending-products');
  return response.data;
};

const productService = {
  getProducts,
  getProductById,
  searchProducts,
  getNewArrivals,
  getHomepageData,
  getAdminProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  deleteProductImage,
  getAdminNewArrivals,
  getAdminTrendingProducts,
};

export default productService;
